var map = {
	"./i9.png": "ltXf",
	"./i9en.png": "iLTi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+T1n";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet ^\.\/i9.*\.png$
// module id = +T1n
// module chunks = 0